import { type GroupProps } from '@react-three/fiber';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { Group } from 'three';

import Thunderstorm from '0_canvas/Perils/ThunderstormPeril/Thunderstorm/Thunderstorm';

export interface ThunderstormPerilProps extends GroupProps {}

const ThunderstormPeril = forwardRef<Group, ThunderstormPerilProps>(
  (props, ref) => {
    const containerRef = useRef<Group>(null!);

    useImperativeHandle(ref, () => containerRef.current);

    return (
      <group ref={containerRef} {...props}>
        <Thunderstorm
          cloudsRadius={340}
          holeRadius={120}
          lightningAreaRadius={80}
          altitude={100}
          baseCloudVolume={25}
          density={0.03}
        />
      </group>
    );
  }
);

ThunderstormPeril.displayName = 'ThunderstormPeril';
export default ThunderstormPeril;
